import { useQueryParam } from '@mi-front/core';
import { Alert, AlertTitle } from '@mui/material';
import { useIntl } from 'react-intl';

import type { AuthErrorCode } from '@app/core/auth/errors/auth-errors';
import { authErrorMessages } from '@app/core/auth/errors/auth-errors';

/**
 * Self-contained alert that reads login_error from the URL and shows
 * a localized message when the code is known.
 */
export function LoginErrorAlert() {
  const { $t } = useIntl();
  const loginErrorCode = useQueryParam('login_error');

  const displayMessage =
    loginErrorCode && Object.prototype.hasOwnProperty.call(authErrorMessages, loginErrorCode)
      ? $t(authErrorMessages[loginErrorCode as AuthErrorCode])
      : null;

  if (!displayMessage) {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ mt: 3 }}>
      <AlertTitle>
        {$t({
          id: 'auth.loginScreen.errorTitle',
          defaultMessage: 'No se pudo iniciar sesión',
        })}
      </AlertTitle>
      {displayMessage}
    </Alert>
  );
}
